module.exports = __webpack_public_path__ + "static/media/eTenderSubBanner.37822969.jpeg";